/* Shared */
import mtrlModals from 'shared/modals/mtrl_modals';

/* Packs Contents */
import Contact from 'packs_contents/contact'

TeePublic.Contact = Contact;

mtrlModals.mtrlModal();
